import { SET_PRODUCTS_STOCK_DATA } from "../actionTypes";
import { ProductStock } from "../../Types/PrismaSwift";

export const setProductsStockDataAction = (payload: ProductStock[] | []) => {
  return {
    type: SET_PRODUCTS_STOCK_DATA as typeof SET_PRODUCTS_STOCK_DATA,
    payload: payload,
  };
};
